<p-button
  ospButtonFocusHandler
  [disabled]="$disabled()"
  [severity]="$severity()"
  [outlined]="$outlined()"
  [text]="$text()"
  [rounded]="$rounded()"
  [styleClass]="$cssClass()"
  [pTooltip]="$tooltip()"
  [tooltipPosition]="$tooltipPosition()"
  [badge]="$badge()"
  [badgeClass]="$badgeClass()"
  [tabIndex]="$tabIndex()"
  [ariaLabel]="$ariaLabel()"
  (click)="handleClick($event)"
  [class.icon-only]="$iconOnly() || ($icon() && !$label())"
>
  <ng-content></ng-content>
  @if ($loading()) {
    <div class="inner-container justify-content-center">
      <i [class]="$loadingIcon()"></i>
    </div>
  } @else {
    @if ($icon()) {
      <div
        class="inner-container"
        [ngClass]="{
          'inner-container--right': $iconPos() === 'right',
          'inner-container--top': $iconPos() === 'top',
          'inner-container--bottom': $iconPos() === 'bottom',
          'inner-container--icon-only': !$label()
        }"
      >
        <i [class]="$icon()"></i>
        {{ $label() }}
      </div>
    } @else {
      <span>{{ $label() }}</span>
    }
  }
</p-button>
